const SUBSCRIPTION_LEVELS: ManageAccount.SubscriptionLevel[] = ['KS4', 'KS5', 'KS4KS5'];

export const isSubscriptionPrices = (value: unknown): value is ManageAccount.SubscriptionPrices => {
	if (!value || typeof value !== 'object') return false;
	return SUBSCRIPTION_LEVELS.every((level) => {
		const entry = (value as Record<string, unknown>)[level];
		if (!entry || typeof entry !== 'object') return false;

		const priceArrays = Object.values(entry as Record<string, unknown>).filter(
			Array.isArray
		) as unknown[];
		return (
			priceArrays.length > 0 &&
			priceArrays.every(
				(prices) =>
					Array.isArray(prices) &&
					prices.length >= 3 &&
					prices.every((price) => typeof price === 'number')
			)
		);
	});
};
